/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function coerceToString(obj) {
    if (typeof obj === 'string') {
        return obj;
    }
    else if (obj == null) {
        return '';
    }
    else {
        return obj.toString();
    }
}
// All values above this cutoff should still be considered quite similar, below
// this value it is simply never really similar.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SIMILARITY_CUTOFF = 0.7;
/**
 * Get a function that returns the Sørensen–Dice coefficient between
 * the given input and the argument to the returned function.
 *
 * @param first The base string.
 * @returns A function that takes one string, `second`, and returns the
 * Sørensen–Dice coefficient between `first` and `second`.
 */
export function stringSimilarityFor(first) {
    // eslint-disable-next-line
    first = first.replace(/\s+/g, '');
    const firstBigrams = new Map();
    for (let i = 0, end = first.length - 1; i < end; i++) {
        const bigram = first.substring(i, i + 2);
        const count = (firstBigrams.get(bigram) ?? 0) + 1;
        firstBigrams.set(bigram, count);
    }
    return (second) => {
        // eslint-disable-next-line
        second = second.replace(/\s+/g, '');
        if (first === second) {
            return 1;
        }
        if (first.length < 2 || second.length < 2) {
            return 0;
        }
        const seenBigrams = new Map();
        let intersectionSize = 0;
        for (let i = 0, end = second.length - 1; i < end; i++) {
            const bigram = second.substring(i, i + 2);
            const firstCount = firstBigrams.get(bigram) ?? 0;
            // Didn't see this bigram, so simply skip it.
            if (firstCount === 0) {
                continue;
            }
            const seenCount = seenBigrams.get(bigram) ?? 0;
            if (firstCount > seenCount) {
                seenBigrams.set(bigram, seenCount + 1);
                intersectionSize++;
            }
        }
        return (2.0 * intersectionSize) / (first.length + second.length - 2);
    };
}
